export default function categoryUrl(slug, keyword = null) {
  return `/category/${slug}/${keyword || ''}`
}
